import { Row, Col, Flex, Icon } from "@/base/index";
import { useBreakpoint } from "@/base/utils/index";
import IcoLogoSvg from "../../static/footer-navigate-ico-logo.svg?react";
import SocLogoSvg from "../../static/footer-navigate-soc-logo.svg?react";
import { LocalizationAvailableLangType } from "@/schemas/index";
import { useFooterNavigateStyles } from "./footer-navigate.styles";
import { useContextPageRoot } from "../../context/root-context";
import { Link } from "@/components/link";

const footerHelpItems = (lang: LocalizationAvailableLangType) => [
  {
    text: "Privacy Policy",
    href: `/${lang}/privacy-policy`,
    target: "_self",
  },
  {
    text: "Cookies Policy",
    href: `/${lang}/cookie-policy`,
    target: "_self",
  },
  {
    text: "Terms and Conditions",
    href: `/${lang}/terms-and-conditions`,
    target: "_self",
  },
];

export const FooterNavigateHelp = () => {
  const screens = useBreakpoint();
  const { styles } = useFooterNavigateStyles();
  const { localization } = useContextPageRoot();
  const { currentLang } = localization;

  return (
    <div className={styles.help}>
      <Row gutter={[32, 32]} align={"middle"} wrap={!screens.md}>
        {footerHelpItems(currentLang!).map((item, key) => (
          <Col key={key} xs={{ flex: "50%" }} md={{ flex: "25%" }}>
            <Link to={item.href} target={item.target}>
              {item.text}
            </Link>
          </Col>
        ))}
        <Col xs={{ flex: "100%" }} md={{ flex: "25%" }}>
          <Flex gap={32} justify={screens.md ? "flex-end" : "flex-start"}>
            <Icon size={72} component={IcoLogoSvg} />
            <Icon size={72} component={SocLogoSvg} />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
